import React from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #111827;
`;

const LoadingText = styled.div`
  color: #9ca3af;
  font-size: 14px;
  text-align: center;
  padding: 24px 0;
`;

const ErrorText = styled.div`
  color: #ef4444;
  font-size: 14px;
  text-align: center;
  padding: 24px 0;
`;

export default function Panel({ title, isLoading, error, actions, children }) {
  return (
    <Card>
      <Header>
        <Title>{title}</Title>
        {actions && <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>{actions}</div>}
      </Header>
      {isLoading ? (
        <LoadingText>로딩 중...</LoadingText>
      ) : error ? (
        <ErrorText>데이터를 불러올 수 없습니다</ErrorText>
      ) : (
        children
      )}
    </Card>
  );
}
